export class VariantEfficiencyRequest {
    variantCode:string;
    constructor(variantCode:string){
        this.variantCode = variantCode;
    }
}


